/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import React__default from 'react';
import '../styled/StyledTag.js';
import { StyledAvatar } from '../styled/StyledAvatar.js';
import '../styled/StyledClose.js';

const AvatarComponent = props => React__default.createElement(StyledAvatar, props);
AvatarComponent.displayName = 'Tag.Avatar';
const Avatar = AvatarComponent;

export { Avatar };
